import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { usePlaidLink } from "react-plaid-link";

import { useQuery } from "hooks/useQuery";
import { useNavigation } from "utils/navigate";
import { fetchUserDetails } from "Layout/slice/thunk";
import { getSurmountAccountDetails } from "../service";
import { usePortfolioData } from "features/Dashboard/hook";
import { useSurmountDocuments, useSurmountTransactions } from "../hook";
import { updatePlaidConsent } from "features/SurmountAccount/service.js";

export const SURMOUNT_ACCOUNT_DETAILS_QUERY_KEY = "surmountAccountDetails";

export const useSurmountAccountDetails = (id) => {
  const dispatch = useDispatch();
  const { navigateToDashboard } = useNavigation();
  const [plaidConfig, setPlaidConfig] = useState({ token: "" });

  const { ready, open } = usePlaidLink(plaidConfig);
  const { refetch: refetchSurmountDoc } = useSurmountDocuments();
  const { refetch: refetchPortfolioData } = usePortfolioData(id);
  const { refetch: refetchSurmountTransac } = useSurmountTransactions();

  const { data, isLoading, refetch } = useQuery({
    queryKey: [SURMOUNT_ACCOUNT_DETAILS_QUERY_KEY],
    queryFn: getSurmountAccountDetails,
    onError: async (error) => {
      if (error.response.data.code === "ITEM_LOGIN_REQUIRED") {
        const response = await updatePlaidConsent();
        if (!plaidConfig.token) {
          setPlaidConfig({
            token: response.link_token,
            onSuccess,
            onExit,
          });
        }
        if (ready) {
          open();
        }
      }
    },
  });

  const onSuccess = useCallback(() => {
    try {
      dispatch(fetchUserDetails());
      refetch();
      refetchPortfolioData();
      refetchSurmountTransac();
      refetchSurmountDoc();

      setPlaidConfig({
        ...plaidConfig,
        token: "",
      });
    } catch (error) {
      console.error("error: ", error);
    }
  }, [plaidConfig.token]);

  const onExit = useCallback(() => {
    try {
      navigateToDashboard();
    } catch (error) {
      console.error("error: ", error);
    }
  }, [plaidConfig.token]);

  return {
    accountDetails: data,
    isLoading,
    refetchDetails: refetch,
    refetchPortfolio: refetchPortfolioData,
    refetchTransactions: refetchSurmountTransac,
    refetchDocuments: refetchSurmountDoc,
  };
};
